// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.customization-docs-screen {
  position: relative;
  height: auto;
  line-height: 1.25rem;
  font-size: 0.9rem;
  color: var(--black5);
  margin-bottom: 0;
}
.customization-docs-screen b {
  font-weight: 500;
  color: var(--black9);
}
.customization-docs-screen ul.customization-docs-screen-list > li {
  margin-bottom: 1.5rem;
}
.customization-docs-screen ul.customization-docs-screen-list > li:last-child {
  margin-bottom: 0;
}
.customization-docs-screen-list-header {
  margin-bottom: 0.75rem;
}
.customization-docs-screen ul li {
  margin-bottom: 0.25rem;
}
.customization-docs-screen ul li:last-child {
  margin-bottom: 1rem;
}
.customization-docs-screen ul li b {
  font-weight: 500;
  color: var(--black9);
}
.customization-docs-screen-img {
  width: 100%;
  height: auto;
  margin-bottom: 1rem;
}
.customization-docs-screen-img img {
  width: 100%;
  height: auto;
}
.customization-docs-screen-body {
  background: var(--white);
  box-shadow: 0 1px 3px rgba(7, 14, 35, 0.06), 0 2px 8px -1px rgba(7, 14, 35, 0.05);
  border-radius: 0.5rem;
  padding: 1.25rem;
}
.customization-docs-screen h6 {
  margin: 1.25rem 0;
  font-weight: 600;
  font-size: 1rem;
  line-height: 1.2rem;
  color: var(--black9);
}
.customization-docs-screen h6:first-child {
  margin-top: 0;
}
.customization-docs-screen h5 {
  margin: 0.5rem 0;
  font-weight: 600;
  font-size: 0.9rem;
  line-height: 1.25rem;
  color: var(--black9);
}
.customization-docs-screen a {
  color: var(--purple6);
}
.customization-docs-screen p {
  margin: 0;
}
.customization-docs-screen ul {
  margin: 0;
}
.customization-docs-screen .class-var {
  background-color: var(--purple6);
  color: white;
  font-size: 0.9rem;
  font-weight: normal;
  display: inline-flex;
  padding: 0.125rem 0.5rem;
  border-radius: 0.25rem;
}
.customization-docs-screen .important {
  background-color: var(--purple1);
  color: var(--purple6);
  font-size: 0.9rem;
  font-weight: normal;
  display: inline-flex;
  padding: 0.125rem 0.5rem;
  border-radius: 0.25rem;
}
.customization-docs-screen .code-block-container {
  border: 1px solid var(--black2);
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05);
  border-radius: 0.5rem;
}
.customization-docs-screen .code-block-container .code-block-content {
  padding: 1.25rem 1rem;
}
.customization-docs-screen .code-block-container .expanded-icon svg, .customization-docs-screen .code-block-container .collapsed-icon svg {
  vertical-align: baseline !important;
}
.customization-docs-screen .code-block-container svg {
  color: var(--purple6);
}
.customization-docs-screen .code-block-container pre {
  position: relative;
  margin: 0;
  padding: 1.25rem 1rem !important;
  background: transparent !important;
  color: var(--black9) !important;
}
.customization-docs-screen .code-block-container pre .linenumber {
  padding-right: 1.5rem !important;
  color: var(--black3);
}
.customization-docs-screen .code-block-container pre::before {
  position: absolute;
  top: -1.25rem;
  left: 2rem;
  height: calc(100% + 1.25rem);
  width: 1px;
  background-color: var(--black2);
}
.customization-docs-screen .code-block-container .custom-code-block-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 1.25rem;
  background: var(--black0);
  text-transform: none;
  border-bottom: 1px solid var(--black2);
  border-radius: 0.5rem 0.5rem 0 0;
  box-sizing: border-box;
}
.customization-docs-screen .code-block-container .custom-code-block-header p {
  margin: 0;
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.25rem;
  color: var(--black5);
}`, "",{"version":3,"sources":["webpack://./client/entrypoints/dashboard/screens/customization/documentation/index.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,YAAA;EACA,oBAAA;EACA,iBAAA;EACA,oBAAA;EACA,gBAAA;AACF;AACE;EACE,gBAAA;EACA,oBAAA;AACJ;AAII;EACE,qBAAA;AAFN;AAIM;EACE,gBAAA;AAFR;AAQE;EACE,sBAAA;AANJ;AAUI;EACE,sBAAA;AARN;AAUM;EACE,mBAAA;AARR;AAWM;EACE,gBAAA;EACA,oBAAA;AATR;AAcE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AAZJ;AAcI;EACE,WAAA;EACA,YAAA;AAZN;AAgBE;EACE,wBAAA;EACA,iFAAA;EACA,qBAAA;EACA,gBAAA;AAdJ;AAiBE;EACE,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;AAfJ;AAiBI;EACE,aAAA;AAfN;AAmBE;EACE,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,oBAAA;AAjBJ;AAoBE;EACE,qBAAA;AAlBJ;AAqBE;EACE,SAAA;AAnBJ;AAsBE;EACE,SAAA;AApBJ;AAuBE;EACE,gCAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,oBAAA;EACA,wBAAA;EACA,sBAAA;AArBJ;AAwBE;EACE,gCAAA;EACA,qBAAA;EACA,iBAAA;EACA,mBAAA;EACA,oBAAA;EACA,wBAAA;EACA,sBAAA;AAtBJ;AAyBE;EACE,+BAAA;EACA,4CAAA;EACA,qBAAA;AAvBJ;AAyBI;EACE,qBAAA;AAvBN;AA4BM;EACE,mCAAA;AA1BR;AA6BI;EACE,qBAAA;AA3BN;AA8BI;EACE,kBAAA;EACA,SAAA;EACA,gCAAA;EACA,kCAAA;EACA,+BAAA;AA5BN;AA8BM;EACE,gCAAA;EACA,oBAAA;AA5BR;AA+BM;EAEE,kBAAA;EACA,aAAA;EACA,UAAA;EACA,4BAAA;EACA,UAAA;EACA,+BAAA;AA9BR;AAkCI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,wBAAA;EACA,yBAAA;EACA,oBAAA;EACA,sCAAA;EACA,gCAAA;EACA,sBAAA;AAhCN;AAkCM;EACE,SAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;EACA,oBAAA;AAhCR","sourcesContent":[".customization-docs-screen {\n  position: relative;\n  height: auto;\n  line-height: 1.25rem;\n  font-size: .9rem;\n  color: var(--black5);\n  margin-bottom: 0;\n\n  b {\n    font-weight: 500;\n    color: var(--black9);\n  }\n\n  ul.customization-docs-screen-list {\n\n    & > li {\n      margin-bottom: 1.5rem;\n\n      &:last-child {\n        margin-bottom: 0;\n      }\n    }\n  }\n\n\n  &-list-header {\n    margin-bottom: .75rem;\n  }\n\n  ul {\n    li {\n      margin-bottom: 0.25rem;\n\n      &:last-child {\n        margin-bottom: 1rem;\n      }\n\n      b {\n        font-weight: 500;\n        color: var(--black9);\n      }\n    }\n  }\n\n  &-img {\n    width: 100%;\n    height: auto;\n    margin-bottom: 1rem;\n\n    img {\n      width: 100%;\n      height: auto;\n    }\n  }\n\n  &-body {\n    background: var(--white);\n    box-shadow: 0 1px 3px rgb(7 14 35 / 6%), 0 2px 8px -1px rgb(7 14 35 / 5%);\n    border-radius: 0.5rem;\n    padding: 1.25rem;\n  }\n\n  h6 {\n    margin: 1.25rem 0;\n    font-weight: 600;\n    font-size: 1rem;\n    line-height: 1.2rem;\n    color: var(--black9);\n\n    &:first-child {\n      margin-top: 0;\n    }\n  }\n\n  h5 {\n    margin: 0.5rem 0;\n    font-weight: 600;\n    font-size: 0.9rem;\n    line-height: 1.25rem;\n    color: var(--black9);\n  }\n\n  a {\n    color: var(--purple6);\n  }\n\n  p {\n    margin: 0;\n  }\n\n  ul {\n    margin: 0;\n  }\n\n  .class-var {\n    background-color: var(--purple6);\n    color: white;\n    font-size: 0.9rem;\n    font-weight: normal;\n    display: inline-flex;\n    padding: 0.125rem 0.5rem;\n    border-radius: 0.25rem;\n  }\n\n  .important {\n    background-color: var(--purple1);\n    color: var(--purple6);\n    font-size: 0.9rem;\n    font-weight: normal;\n    display: inline-flex;\n    padding: 0.125rem 0.5rem;\n    border-radius: 0.25rem;\n  }\n\n  .code-block-container {\n    border: 1px solid var(--black2);\n    box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05);\n    border-radius: 0.5rem;\n\n    .code-block-content {\n      padding: 1.25rem 1rem;\n\n    }\n\n    .expanded-icon, .collapsed-icon {\n      svg {\n        vertical-align: baseline !important;\n      }\n    }\n    svg {\n      color: var(--purple6);\n    }\n\n    pre {\n      position: relative;\n      margin: 0;\n      padding: 1.25rem 1rem !important;\n      background: transparent !important;\n      color: var(--black9) !important;\n\n      .linenumber {\n        padding-right: 1.5rem !important;\n        color: var(--black3);\n      }\n\n      &::before {\n        //content: '';\n        position: absolute;\n        top: -1.25rem;\n        left: 2rem;\n        height: calc(100% + 1.25rem);\n        width: 1px;\n        background-color: var(--black2);\n      }\n    }\n\n    .custom-code-block-header {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      padding: 0.75rem 1.25rem;\n      background: var(--black0);\n      text-transform: none;\n      border-bottom: 1px solid var(--black2);\n      border-radius: 0.5rem 0.5rem 0 0;\n      box-sizing: border-box;\n\n      p {\n        margin: 0;\n        font-size: 0.875rem;\n        font-weight: 600;\n        line-height: 1.25rem;\n        color: var(--black5);\n      }\n    }\n  }\n\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
